import { useState } from 'react'
import HeaderLayout from '../../../../layouts/Header'
import PageHeader from '../../../../layouts/PageHeader'
import { Button } from '../../../../components/ui/legacy'
import { Icon } from '@iconify/react'
import FormCreateAdminModal from './FormCreateAdminModal'

// Tìm kiếm tên tài khoản, mã tài khoản...
export default function AdminPermissionHeader() {
  const [isAddFormOpen, setIsAddFormOpen] = useState(null)
  return (
    <>
      <HeaderLayout className="flex flex-row items-center justify-between gap-3">
        <PageHeader>Danh sách quản trị viên</PageHeader>
        <Button
          variant={'primary'}
          onClickHandler={() => {
            setIsAddFormOpen(true)
          }}
          className=""
        >
          <Icon
            icon="ph:user"
            width="1.5rem"
            className="aspect-square text-[white]"
          />
          <p className="text-white">Thêm quản trị viên</p>
        </Button>
      </HeaderLayout>
      {isAddFormOpen && (
        <FormCreateAdminModal
          onClose={() => {
            setIsAddFormOpen(null)
          }}
        />
      )}
    </>
  )
}
